import { createContext, useContext, type ReactNode } from 'react'
import type { HelpSeat } from './types.js'

const HelpSeatContext = createContext<HelpSeat | null>(null)

/** Set once by each shell: who the help is written for in this session. Without it no help icon renders. */
export function HelpSeatProvider({ seat, children }: { seat: HelpSeat; children: ReactNode }) {
  return <HelpSeatContext.Provider value={seat}>{children}</HelpSeatContext.Provider>
}

export function useHelpSeat(): HelpSeat | null {
  return useContext(HelpSeatContext)
}
